// extracted by mini-css-extract-plugin
export default {"textBox":"ep6nbL5y7OBd1WhkcnLA","tooltip":"A9y_xe511dllAA6Glash"};